/* HEMATIX consented first-party attribution. No checkout interception. */
(function () {
  'use strict';
  if (!window.Shopify || Shopify.designMode) return;
  var key = 'hmx_paid_touch', pending = null, lastWritten = null;
  var q = new URLSearchParams(location.search);
  var source = (q.get('tw_source') || q.get('utm_source') || '').toLowerCase();
  var campaign = q.get('tw_campaign') || q.get('campaign_id') || q.get('gad_campaignid') || q.get('utm_campaign') || '';
  var ad = q.get('ad_id') || q.get('tw_adid') || q.get('utm_content') || '';
  var google = /^(google|googleads|google_ads)$/.test(source) || q.has('gclid') || q.has('gbraid') || q.has('wbraid');
  var meta = /^(facebook|fb|instagram|ig|meta)$/.test(source) || q.has('fbclid');
  var paid = q.has('gclid') || q.has('gbraid') || q.has('wbraid') || /^(cpc|ppc|paid|paid_social|paid_search)$/.test(q.get('utm_medium') || '') || /^\d{5,30}$/.test(ad) || (q.get('tw_source') && /^\d{5,30}$/.test(campaign));
  if (paid) pending = { v: 1, at: new Date().toISOString(), source: google ? 'google' : meta ? 'meta' : 'unknown', campaign: /^\d{5,30}$/.test(campaign) ? campaign : '', ad: /^\d{5,30}$/.test(ad) ? ad : '', host: location.hostname };
  function allowed() { return Shopify.customerPrivacy && Shopify.customerPrivacy.analyticsProcessingAllowed(); }
  function write(value) {
    if (value === lastWritten) return;
    lastWritten = value;
    var attributes = {}; attributes.__hmx_paid_touch = value; // Shopify private cart attribute
    fetch((Shopify.routes && Shopify.routes.root || '/') + 'cart/update.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:attributes}),keepalive:true}).then(function(r){if(!r.ok)lastWritten=null;}).catch(function(){lastWritten=null;});
  }
  function capture() {
    if (!allowed()) return;
    var touch = pending;
    var hadCookie = document.cookie.indexOf(key+'=') !== -1;
    if (!touch) { try { var c = document.cookie.split('; ').find(function(x){return x.indexOf(key+'=')===0;}); touch = c && JSON.parse(decodeURIComponent(c.slice(key.length+1))); } catch (_) {} }
    if (!touch || touch.v !== 1 || Date.now()-Date.parse(touch.at)>604800000 || Date.parse(touch.at)>Date.now()) {
      // Pas de clic payant connu : aucune requête (sinon un POST cart/update par page vue pour chaque visiteur).
      // Un cookie périmé est effacé une fois, et l'attribut du panier vidé avec lui.
      if (hadCookie) { document.cookie=key+'=; Max-Age=0; Path=/; Domain=myhematix.com; SameSite=Lax; Secure'; write(''); }
      return;
    }
    var value=JSON.stringify(touch);
    if (pending) { document.cookie=key+'='+encodeURIComponent(value)+'; Max-Age=604800; Path=/; Domain=myhematix.com; SameSite=Lax; Secure'; pending=null; }
    write(value);
  }
  document.addEventListener('visitorConsentCollected',function(){if(allowed())capture();else{document.cookie=key+'=; Max-Age=0; Path=/; Domain=myhematix.com; SameSite=Lax; Secure';write('');}});
  window.addEventListener('pageshow',capture);
  if (Shopify.customerPrivacy) capture();
  else if (Shopify.loadFeatures) Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(error){if(!error)capture();});
})();
